var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpectra = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.2,
    viewBox: "0 0 24 19.2",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(-568 -53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M12.96,0H0V8.4l6.845.517,3.378,2.242V8.917L12.96,8.4Z",
    transform: "translate(575.32 53.781)",
    fill: "var(--photon-product-muted)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "chatbox-outline",
    d: "M14.538,8.375H4.6A2.351,2.351,0,0,0,2.25,10.7v5.6A2.351,2.351,0,0,0,4.6,18.631H9.9l2.99,2.465a.528.528,0,0,0,.557.071.517.517,0,0,0,.3-.468V18.631h.784a2.351,2.351,0,0,0,2.353-2.325V10.7A2.351,2.351,0,0,0,14.538,8.375ZM4.6,17.6A1.308,1.308,0,0,1,3.3,16.3V10.7A1.308,1.308,0,0,1,4.6,9.409h9.931A1.308,1.308,0,0,1,15.844,10.7v5.6A1.308,1.308,0,0,1,14.536,17.6H13.23a.52.52,0,0,0-.523.517v1.481L10.5,17.777a.791.791,0,0,0-.5-.18Z",
    transform: "translate(572.11 44.625)",
    fill: "var(--photon-product-muted)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M0,0H12.96V8.4l-6.845.517L2.737,11.159V8.917L0,8.4Z",
    transform: "translate(568.84 57.44)",
    fill: "var(--photon-product-primary)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M12.96,0H0V8.4l6.845.517,3.378,2.242V8.917L12.96,8.4Z",
    transform: "translate(578.2 60.201)",
    fill: "var(--photon-product-secondary)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "chatbox-outline-2",
    "data-name": "chatbox-outline",
    d: "M4.6,8.375h9.935A2.351,2.351,0,0,1,16.89,10.7v5.6a2.351,2.351,0,0,1-2.352,2.326h-5.3L6.245,21.1a.528.528,0,0,1-.557.071.517.517,0,0,1-.3-.468V18.631H4.6A2.351,2.351,0,0,1,2.25,16.306V10.7A2.351,2.351,0,0,1,4.6,8.375ZM14.537,17.6A1.308,1.308,0,0,0,15.844,16.3V10.7a1.308,1.308,0,0,0-1.309-1.292H4.6A1.308,1.308,0,0,0,3.3,10.7v5.6A1.308,1.308,0,0,0,4.6,17.6H5.91a.52.52,0,0,1,.523.517v1.481l2.205-1.817a.791.791,0,0,1,.5-.18Z",
    transform: "translate(565.75 48.225)",
    fill: "var(--photon-product-gradient-start)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chatbox-outline-3",
    "data-name": "chatbox-outline",
    d: "M14.538,8.375H4.6A2.351,2.351,0,0,0,2.25,10.7v5.6A2.351,2.351,0,0,0,4.6,18.631H9.9l2.99,2.465a.528.528,0,0,0,.557.071.517.517,0,0,0,.3-.468V18.631h.784a2.351,2.351,0,0,0,2.353-2.325V10.7A2.351,2.351,0,0,0,14.538,8.375ZM4.6,17.6A1.308,1.308,0,0,1,3.3,16.3V10.7A1.308,1.308,0,0,1,4.6,9.409h9.931A1.308,1.308,0,0,1,15.844,10.7v5.6A1.308,1.308,0,0,1,14.536,17.6H13.23a.52.52,0,0,0-.523.517v1.481L10.5,17.777a.791.791,0,0,0-.5-.18Z",
    transform: "translate(575.11 50.985)",
    fill: "var(--photon-product-secondary)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpectra);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Spectra.2fb970b2ee80ff8ceaa9ddc8712a5b9e.svg";